/* global axios */
import ApiClient from './ApiClient';

class FlowsAPI extends ApiClient {
  constructor() {
    super('flows', { accountScoped: true });
  }

  activate(flowId) {
    return axios.post(`${this.url}/${flowId}/activate`);
  }

  deactivate(flowId) {
    return axios.post(`${this.url}/${flowId}/deactivate`);
  }

  executions(flowId) {
    return axios.get(`${this.url}/${flowId}/executions`);
  }

  validate(flowId, draftSchema) {
    return axios.post(`${this.url}/${flowId}/validate`, {
      draft_schema: draftSchema,
    });
  }
}

export default new FlowsAPI();
